import { Outlet, createFileRoute } from "@tanstack/react-router";

import { ProductLogoMediumApps as LogoApps } from "@/components/Logo";
import type { TabWithIndicatorProps } from "@/components/Navigation/HeaderTabs";
import { ProductHeader } from "@/components/ProductHeader";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { useTranslation } from "@/lib/i18n";

export const Route = createFileRoute("/_staff/apps/_list")({
  component: AppsLayout,
});

function AppsLayout() {
  const { t } = useTranslation();
  useDocumentTitle(t("pages.apps.title"));

  const tabs = [
    {
      to: "/apps",
      children: t("common.list.overview"),
      activeOptions: { exact: true },
    },
    { to: "/apps/integrations", children: t("common.list.integrations") },
    { to: "/apps/people", children: t("common.list.people") },
    {
      to: "/apps/alerts",
      children: t("common.list.alerts"),
      activeOptions: { includeSearch: true, exact: false },
    },
    {
      to: "/apps/contract-and-cost",
      children: t("common.list.contractAndCost"),
    },
    {
      to: "/apps/operation-activity",
      children: t("common.list.operationActivity"),
    },
    { to: "/apps/marketplace", children: t("common.list.marketplace") },
    {
      to: "/apps/rule-and-policy",
      children: t("common.list.ruleAndPolicy"),
    },
    { to: "/apps/settings", children: t("common.list.settings") },
  ] satisfies TabWithIndicatorProps[];

  return (
    <div className="flex flex-col">
      <ProductHeader
        Logo={LogoApps}
        name={t("pages.apps.title")}
        tabs={tabs}
        type="resource"
      />
      <Outlet />
    </div>
  );
}
